import {Injectable} from '@angular/core';
import { Router} from '@angular/router';
import {Actions, createEffect,  ofType} from '@ngrx/effects';
import {Action, select, Store} from '@ngrx/store';
import {catchError,  map, switchMap, withLatestFrom} from 'rxjs/operators';
import {error, success} from '../../shared/actions/toasts';
import {BaseEffect} from '../../shared/effects/base.effect';
import {debug} from '../../../rxjs-operators';
import * as fromShared from '../../shared/reducers';
import {of} from 'rxjs';
import {SendBackResult} from '../../shared';
import {ContractLinkServiceService} from '../services/contract-link.service';
import {
  linkContractUpdateActionTypes,
  UpdateLinkContractAction,
  UpdateLinkContractFailAction,
  UpdateLinkContractSuccessAction
} from '../actions/link-contract-update';
import {LinkContractMapperService} from '../services/link-contract-mapper.service';
import {LoadContractsAction} from '../../contract/actions/contracts-list';
import {LoadSubAnomalyListAction, LoadSubByClientListAction, LoadSubByContractListAction, LoadSubListAction} from '../actions/subscription-list';
import {L10nTranslationService} from 'angular-l10n';

@Injectable()
export class RulesUpdateEffect extends BaseEffect {


  add$ = createEffect(() => { return this.actions$.pipe(
    ofType(linkContractUpdateActionTypes.UPDATE),
    debug('update contract link action received.'),
    map((action: UpdateLinkContractAction) => action.payload),
    switchMap((payload) =>
      this.contractLinkServiceService.update(this.linkContractMapperService.formToDb(payload.form , payload.subList )).pipe(
        switchMap((res: SendBackResult<boolean>) => of(new UpdateLinkContractSuccessAction(res.data),
         this.updateDate() )),
        catchError(res => this.catchResponseError(res)))))
  });

  addSuccess$ = createEffect(() => { return this.actions$.pipe(
    ofType(linkContractUpdateActionTypes.UPDATE_SUCCESS),
    debug('update success contract link action received.'),
    withLatestFrom(this.store.pipe(select(fromShared.selectors.getCurrentClient))),
    switchMap(([data, client]) => [
      success(this.translation.translate('CONTRACT_LINK_SUCCESS'), this.translation.translate('TOAST_SUCCESS_TITLE'))
    ]),
  )});


  addFail$ = createEffect(() => { return this.actions$.pipe(ofType(linkContractUpdateActionTypes.UPDATE_FAIL),
    debug('A server error occurred while update contract.'),
    map((err: UpdateLinkContractFailAction) =>
      error(this.translation.translate('CONTRACT_LINK_ERROR') + ' ' + err.payload, this.translation.translate('TOAST_ERROR_TITLE'))))
  });

  constructor(private actions$: Actions,
              private translation: L10nTranslationService,
              private contractLinkServiceService: ContractLinkServiceService,
              private linkContractMapperService: LinkContractMapperService,
              private store: Store<fromShared.AppState>,
              router: Router) {
    super(router);
  }

  protected handleUnhandledError = (response) => {
    return new UpdateLinkContractFailAction(response['error'].message);
  }

  protected handleGoneError = (response) => {
    return new UpdateLinkContractFailAction(response['error'].message);
  }
  updateDate(): Action {
    // if (this.router.url.split('?')[0].split('/')[1] === 'anomalies') {
    //   return new LoadSubAnomalyListAction();
    // } else {
    //   // tslint:disable-next-line:no-unused-expression
    //   return ( new LoadSubListAction(), new LoadContractsAction())
    // }

    if (this.router.url.split('?')[0].split('/')[1] === 'anomalies') {
      return new LoadSubAnomalyListAction() ;
    } else if (this.router.url.split('?')[0].split('/')[2] === 'sites') {
      return new LoadSubByClientListAction();
    } else if (this.router.url.split('?')[0].split('/')[2] === 'contracts') {
      return new  LoadSubByContractListAction();
    } else {
      return new  LoadSubListAction();
    }
  }
}
